<template>
  <div class="box aaaaa">
    <div class="jbxx bbbbb">
      <div class="edi" style="margin-left: 50px;">
        <el-form
          :model="dataForm"
          :rules="rules"
          ref="dataForm"
          class="demo-ruleForm"
        >
          <div class="tab-form-item">
            <span class="item-title">快递鸟商户ID</span>
            <div class="left-item">
              <el-form-item prop="appId" :rules="rules.appId">
                <el-input
                  v-model="dataForm.appId"
                  placeholder="请输入快递鸟商户ID"
                ></el-input>
              </el-form-item>
              <span class="item-des"
              >商户ID用于获取物流信息(登录快递乌用户管理后台-用户信息里面查看)，快递鸟<a
                href="https://www.kdniao.com/"
              >接口申请</a
              ></span
              >
            </div>
          </div>
          <div class="tab-form-item">
            <span class="item-title">快递鸟APIKEY</span>
            <div class="left-item">
              <el-form-item prop="appKey" :rules="rules.appKey">
                <el-input
                  v-model="dataForm.appKey"
                  placeholder="请输入快递鸟APIKEY"
                ></el-input>
              </el-form-item>
              <span class="item-des"
              >APIKEY移钥(登录快递鸟用户管理后台-用户信息里面查看)</span
              >
            </div>
          </div>
          <div class="tab-form-item">
            <span class="item-title">是否开启</span>
            <div class="left-item">
              <div>
                <el-radio v-model="dataForm.isOpen" label="0">关闭</el-radio>
                <el-radio v-model="dataForm.isOpen" label="1">开启</el-radio>
              </div>
              <span class="item-des"
              >开启以后快递订单支持电子面单打单服务，电子面单支持的物流公司县体详咨询“<a
                href="https://www.kdniao.com/"
              >快递鸟</a
              >"官方</span
              >
            </div>
          </div>
          <div class="tab-form-item">
            <span class="item-title">是否收费</span>
            <div class="left-item">
              <div>
                <el-radio v-model="dataForm.isCharge" label="0">免费</el-radio>
                <el-radio v-model="dataForm.isCharge" label="1">收费</el-radio>
              </div>
              <span class="item-des"
              >“收典橙式"支持査询到多家快递公司物流轨迹，"免典模式"支持査询申通、中通、圆通物流轨迹具体详情咨询"<a
                href="https://www.kdniao.com/"
              >快递鸟</a
              >"官方</span
              >
            </div>
          </div>
          <div class="tab-form-item">
            <span class="item-title">寄件人：</span>
            <div class="left-item">
              <el-form-item prop="name" :rules="rules.name">
                <el-input
                  v-model="dataForm.name"
                  placeholder="请输入寄件人名称"
                ></el-input>
              </el-form-item>
<!--              <span class="item-des">寄件人必填</span>-->
            </div>
          </div>
          <div class="tab-form-item">
            <span class="item-title">寄件人联系电话：</span>
            <div class="left-item">
              <el-form-item prop="mobile" :rules="rules.mobile">
                <el-input
                  v-model="dataForm.mobile"
                  placeholder="请输入寄件人电话"
                ></el-input>
              </el-form-item>
<!--              <span class="item-des">寄件人联系电话必填</span>-->
            </div>
          </div>
          <div class="tab-form-item">
            <span class="item-title">寄件人省市区:</span>
            <div class="left-item">
              <el-form-item prop="provinceName" :rules="rules.provinceName">
                <el-cascader
                  v-model="cityValue"
                  :options="options"
                  @change="handleChange"
                ></el-cascader>
              </el-form-item>
<!--              <span class="item-des">寄件人省市区必填</span>-->
            </div>
          </div>
          <div class="tab-form-item">
            <span class="item-title">寄件人详细地址:</span>
            <div class="left-item">
              <el-form-item prop="expressAddress" :rules="rules.expressAddress">
                <el-input
                  v-model="dataForm.expressAddress"
                  placeholder="请输入寄件人详细地址"
                ></el-input>
              </el-form-item>
<!--              <span class="item-des">寄件人详细地址必填</span>-->
            </div>
          </div>
          <div class="tab-form-item">
            <span class="item-title">快递公司:</span>
            <div class="left-item">
<!--              <el-form-item prop="shipperName" :rules="rules.shipperName">-->
<!--                <el-input-->
<!--                  v-model="dataForm.shipperName"-->
<!--                  placeholder="请输入快递公司"-->
<!--                ></el-input>-->
<!--              </el-form-item>-->
<!--              <span class="item-des">快递公司选填</span>-->
              <el-select
                v-model="dataForm.shipperName"
                placeholder="请选择快递公司"
                @change="changeShipperName"
              >
                <el-option
                  v-for="item in kdList"
                  :key="item.value"
                  :label="item.shipperName"
                  :value="item.shipperCode"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="tab-form-item">
            <span class="item-title">快递公司邮编:</span>
            <div class="left-item">
              <el-form-item prop="shipperCode" :rules="rules.shipperCode">
                <el-input
                  disabled
                  v-model="dataForm.shipperCode"
                  placeholder="请输入邮编"
                ></el-input>
              </el-form-item>
<!--              <span class="item-des"-->
<!--              >快递公司为:EMS(EMS)，邮政快递包事(YZPY)、邮政国内标快(YZBK)时必填</span-->
<!--              >-->
            </div>
          </div>
          <!-- <div class="btn-box">
            <el-button type="primary" @click="submitForm('dataForm')"
              >确认</el-button
            >
          </div> -->
        </el-form>
      </div>
      <div class="butt" style="display: flex; justify-content: center;">
        <el-button
          style="width: 140px; height: 50px;"
          type="primary"
          @click="submitForm('dataForm')"
        >保存</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { regionData, codeToText, textToCode } from 'element-china-area-data'
export default {
  components: {
    // 界面组件引用
    quillEditor
  },
  data () {
    return {
      form: {},
      editorOption: {
        // some quill options 编辑器配置
        // scrollingContainer:true,
      },
      dataForm: {
        appId: '',
        appKey: '',
        isCharge: '0',
        isOpen: '0',
        mobile: '',
        name: '',
        provinceName: '',
        cityName: '',
        expAreaName: '',
        expressAddress: '',
        shipperName: '',
        shipperCode: ''
      },
      rules: {
        appId: [
          { required: true, message: '请输入快递鸟商户ID', trigger: 'blur' }
        ],
        appKey: [
          { required: true, message: '请输入快递鸟APIKEY', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入寄件人名称', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入寄件人电话', trigger: 'blur' }
        ],
        expressAddress: [
          { required: true, message: '请输入寄件人详细地址', trigger: 'blur' }
        ],
        shipperCode: [
          { required: true, message: '请输入邮编', trigger: 'blur' }
        ],
        shipperName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ]
      },
      options: regionData,
      cityValue: [],
      kdList:[]
    }
  },
  created () {
    this.getConfig()
    this.getKdList()
  },
  methods: {
    handleSuccess (response, file, fileList) {
      console.log(response.data.url)
    },
    onEditorBlur (e) {
      console.log('onEditorBlur', e)
    },
    onEditorFocus (e) {
      console.log('onEditorFocus', e)
    },
    onEditorChange (e) {
      console.log('onEditorChange', e)
    },
    onEditorReady (e) {
      console.log('onEditorReady', e)
    },

    changeShipperName(val){
      console.log(val,261)
      const info = this.kdList.find(item=>item.shipperCode === val)
      if(info){
        this.dataForm.shipperCode = info.shipperCode
        this.dataForm.shipperName = info.shipperName
      }
    },

    // 获取物流配置
    async getConfig () {
      let res = await this.$http.post('/kdniaoShipperAccount/queryOne', {})
      if (res.data.code == 200 && res.data.data) {
        this.dataForm = res.data.data
        this.dataForm.isCharge = this.dataForm.isCharge.toString()
        this.dataForm.isOpen = this.dataForm.isOpen.toString()
        this.cityValue = [this.dataForm.provinceCode, this.dataForm.cityCode, this.dataForm.expAreaCode]
      } else {
        this.dataForm = {}
      }
    },

    //查询快递公司
    async getKdList(){
      const res = await this.$http.post('kdniaoShipper/queryList', {})
      if(res.data.code ===200){
        this.kdList = res.data.data
      }
    },

    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dataForm.provinceName = codeToText[this.cityValue[0]]
          this.dataForm.cityName = codeToText[this.cityValue[1]]
          this.dataForm.expAreaName = codeToText[this.cityValue[2]]
          this.dataForm.provinceCode = this.cityValue[0]
          this.dataForm.cityCode = this.cityValue[1]
          this.dataForm.expAreaCode = this.cityValue[2]
          // this.dataForm.merchantCode =
          console.log(this.detail, '=============')

          this.$http.post('/kdniaoShipperAccount/save', this.dataForm).then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              // this.getList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  //background-color: #FFF;

  .search {
    background-color: #fff;
    height: 210px;
    box-sizing: border-box;
    padding-top: 20px;
    padding-left: 20px;

  }

  .search-top {
    height: 40px;
    padding: 2px 2px 2px 2px;
    background-color: rgba(30, 152, 215, 0.14);

    display: flex;
    align-items: center;
    margin-bottom: 2px;

    div {
      width: 150px;
      text-align: center;
    }
  }

  .diatwo {
    display: flex;
    flex-wrap: wrap;
    /* 允许换行 */
    justify-content: space-between;
    /* 子元素之间的间隔均匀分布 */
    box-sizing: border-box;
    padding: 0 30px;

    .info-item {
      flex: 1 1 30%;
      /* 每个项占据容器宽度的30%，允许伸缩 */
      box-sizing: border-box;
      /* 包括内边距和边框在内的总宽度 */
      margin-bottom: 10px;
      /* 每个项的底部外边距 */
      display: flex;
      align-items: center;
    }

    .dialist {
      display: flex;
      flex-wrap: wrap;

      .dia-li {
        width: 300px;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .name {
          font-weight: 700;
          margin-right: 20px;
        }

        img {
          width: 48px;
          height: 47px;
        }
      }
    }

    .diaimg {
      display: flex;
      flex-wrap: wrap;

      .imgbox {
        width: 200px;
        margin-bottom: 15px;

        .name {
          font-weight: 700;
        }

        .imgli {
          display: flex;
          margin-top: 15px;

          img {
            width: 92px;
            height: 65px;
            margin-right: 10px;
          }
        }
      }
    }

    .sh {
      display: flex;
      margin-top: 40px;
      justify-content: space-between;

      textarea {
        width: 620px;
        height: 60px;
        margin-left: 10px;
      }
    }

    .but {
      margin-top: 50px;
      display: flex;
      justify-content: space-between;
      padding: 0 300px;
    }
  }

  .tab {
    background-color: #fff;
    //margin-top: 20px;
    padding: 20px;
  }

  .image-container {
    position: relative;
    display: inline-block;
  }

  .image-preview {
    width: 100%;
    max-width: 100px;
    height: auto;
    cursor: pointer;
  }

  .image-caption {
    position: absolute;
    bottom: 5px;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    text-align: center;
    font-size: 12px;
  }

  .drawer {
    overflow-y: scroll;
    font-size: 12px;

    .drwtop {
      display: flex;
      flex-wrap: wrap;
      padding: 0 10px;

      div {
        width: 30%;
        color: #000;
        height: 50px;

        span {
          color: #494848;
        }
      }
    }

    .image-section {
      display: flex;
      flex-wrap: wrap;
      /* 允许换行 */
      width: 100%;
      margin-bottom: 5px;
      padding-left: 28px;
      box-sizing: border-box;
    }

    .image-item {
      display: flex;
      align-items: center;
      /* 垂直居中 */
      width: calc((90% / 3) - 20px);
      margin-right: 8px;
      /* 右边距，用于分隔每个图片项 */
      margin-left: 12px;
      /* 右边距，用于分隔每个图片项 */
      margin-bottom: 6px;
    }

    .image-item span {
      margin-right: 2px;
      /* 右边距，用于分隔描述和图片 */
    }

    .image-item .el-image {
      margin-left: 6px;
    }

    .image-item img {
      width: 50px;
      /* 图片宽度 */
      height: auto;
      /* 图片高度自适应 */
    }
  }
}

.tab-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  /deep/ .el-input {
    width: 400px;
  }

  /deep/ .el-form-item {
    margin-bottom: 0;
  }

  .item-title {
    font-size: 14px;
    width: 120px;
  }

  .left-item {
    margin-left: 10px;
    display: flex;
    flex-direction: column;

    .item-des {
      font-size: 12px;
      color: #838588;
      margin-top: 15px;
    }
  }

  a {
    //去除默认样式
    text-decoration: none;
    color: #409eff;
  }

}

.btn-box {
  display: flex;
  align-items: center;
  margin: 40px;
}

.ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  /* 限制为两行 */
  overflow: hidden;
  text-overflow: ellipsis;
  width: 120px;
}

::v-deep .tab-form-item {
  margin-bottom: 15px !important;
}
</style>
